import { MenuItem, styled } from "@mui/material"
import type { CSSProperties } from "react"
import { Link } from "react-router"

export const IconStyles: CSSProperties = {
  marginRight: "8px",
}

export const ActionMenuItem = styled(MenuItem)({
  padding: "6px 12px",
})

export const ActionMenuLink = styled(Link)({
  display: "flex",
  flexDirection: "row",
  textDecoration: "none",
})
